// extracted by mini-css-extract-plugin
module.exports = {"rightColumn":"style-module__rightColumn___A4gho","select":"style-module__select___2FXRV"};